import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-reviews-pager',
    templateUrl: './reviews-pager.component.html',
    styleUrls: ['./reviews-pager.component.scss']
})
export class ReviewsPagerComponent implements OnInit {
    @Input() data: any[] = [];
    @Output() pageChange: EventEmitter<any[]> = new EventEmitter<any[]>();
    currentpage = 0;
    @Input() perPage = 3;
    pages: number = 0;

    buttons = [];

    constructor() {
    }

    ngOnInit(): void {
        this.generatePages();
        this.pageClick(this.currentpage);
    }

    generatePages() {
        this.pages = Math.ceil(this.data.length / this.perPage);
        this.buttons = new Array(this.pages).fill(0).map((el, i) => i);
    }

    pageClick(page: number) {
        const take = (arr, n) => arr.slice(n * this.perPage, n * this.perPage + this.perPage);
        this.pageChange.emit(take(this.data, page));
        this.currentpage = page;
    }
}
